import { useSelector } from 'react-redux';
import { getDefaultStatesWithFeeIncluded } from 'pages/search/hooks/total-price-toggle/use-fetch-states-with-fee-included';
export const useStatesWithFeeIncluded = () => {
    const statesWithFeeIncluded = useSelector((state) => state.search.statesWithFeeIncluded);
    return statesWithFeeIncluded || getDefaultStatesWithFeeIncluded();
};
